const MetodoPago = [
  {
    value: '',
    label: 'Selecciona método de pago'
  },
  {
    value: 'PUE',
    label: 'Pago en una sola exhibición'
  },
  {
    value: 'PPD',
    label: 'Pago en parcialidades o diferido'
  },
]

export default MetodoPago;